/**
 * The /dataseries endpoint takes numeric measure channel ids, while every other layer of the
 * feature uses the namespaced string id shared with /measurechannels. This is the single place
 * that knows the format; it can be removed once the endpoint accepts the string ids directly.
 */
const MEASURE_CHANNEL_ID_PATTERN = /^measure-channel:(\d+)$/;

export function getMeasureChannelIds(selectedSeriesIds: string[]): number[] {
  return selectedSeriesIds.flatMap((seriesId) => {
    const match = MEASURE_CHANNEL_ID_PATTERN.exec(seriesId);

    if (!match) {
      return [];
    }

    const channelId = Number(match[1]);

    return Number.isSafeInteger(channelId) ? [channelId] : [];
  });
}
